import React, { useState, useEffect, useRef } from "react";
import SchoolHeader from "../components/HospitalHeader";
import Footer from "../components/Footer";
import { Container, Card, Row, Col, Button, Modal, Form } from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import LoadingBar from "../components/common-components/toaster/loader/loader";
import { FileStructure } from "../components/common-components/FileSystem/FileStructure";
import { RotationReqSchool } from "../components/common-components/FileSystem/RotaionReqFiles";
import hospitalServices from "../services/hospital.services";
import Dropdown from 'react-bootstrap/Dropdown'
import moment from 'moment'
import { MyCreatedFilesStructure } from "../components/common-components/FileSystem/MyCreatedFileStructure";
import RotationReq from "../components/common-components/ShiftRotation/RotationReq";
import { SetUserDetailsToLocal } from "../services/utils";
import { showErrorMessage, showSuccessMessage } from "../services/utils";
import schoolServices from "../services/school_services";
import _ from 'lodash';
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { SignaturedContracts } from "../components/common-components/FileSystem/signaturedContracts";
import { FaChevronRight } from "react-icons/fa";

const HospitalDashboard = () => {
    const navigate = useNavigate()
    const Administrative_Ref = useRef(null);
    const Files_Ref = useRef(null);
    const Contracts_Ref = useRef(null);
    const permission = JSON.parse(localStorage.getItem("user"))
    const [files, setFilesData] = useState()
    const [loading, setLoading] = useState(false)
    const [fileName, setFileName] = useState();
    const [fileOpen, setFileOpen] = useState({ isFileOpen: false, isFolderOpen: false })
    const [date, onChange] = useState(new Date());
    const [hospitalData, SethospitalData] = useState()
    const [folderName, setFolderName] = useState({})
    const [idHospital, setHospital] = useState(false)
    const [UtilityList, setUtilityList] = useState({ allRotationReq: [], dayRotation: [] })
    const [myCreatedFile, setMyCreatedFiles] = useState({})
    const [signaturedFolders, setSignaturedFolders] = useState([])
    const [studentlist, setStudentList] = useState()
    const [filterdata, setFilterdata] = useState({ select: false, data: "" })



    useEffect(() => {

        setLoading(true)
        hospitalServices.getHospitalProfile().then(resp => {

            setLoading(false)
            SethospitalData(resp.data)
            setHospital(resp.data.hospitalInfo.user_id)

            getAllSharedFiles(resp.data.hospitalInfo)
            SetUserDetailsToLocal({ user: resp.data.hospitalInfo, is_auth_sub_admin: resp.data.is_auth_sub_admin ? resp.data.is_auth_sub_admin : false })
            getMyFiles(resp.data.hospitalInfo.user_id)
            getStudentfiles()
        }
        ).catch(err => {
            
            setLoading(false)
        })

        signauredDocsFolder("folder")
    }, [])

    const getStudentfiles = () => {

        hospitalServices.getSchoolListSubAdmin()
            .then((res) => {
                setStudentList(res.data.data)
            })
            .catch((err) =>
                showErrorMessage({ message: err.response.data.errors.msg })
            )
    }

    const getAllSharedFiles = (data) => {
        hospitalServices.getSharedFiles(data.user_id)
            .then(res => setFilesData(res.data))
            .catch(err => showErrorMessage({ message: err.response.data.errors.msg }))
    }

    useEffect(() => {
        getRotationHospital()
    }, [date])


    const getRotationHospital = (argData) => {
        hospitalServices.getRotationHospital(date).then(resp => {
            if (!date) {
                resp.data.data.map(curr => {
                    curr.id = curr._id
                    curr.hospitalInfo = curr.hospitalInfo.hospital_name
                    curr.departmentInfo = curr.departmentInfo.department
                    curr.date = `${moment(curr.start_date).format("MM/DD/YYYY")} - ${moment(curr.end_date).format("MM/DD/YYYY")}`
                    curr.time = `${curr.start_time}-${curr.end_time}`
                    setUtilityList(prev => ({ ...prev, "allRotationReq": [...prev.allRotationReq, curr] }))
                })
            }
            else {
                setUtilityList(prev => ({ ...prev, "dayRotation": resp.data.data }))
            }

        }
        ).catch(err => {
            
        })
    }

    const getMyFiles = async (data) => {
        const schoolId = data ? data : idHospital
        await hospitalServices.getFileFolder(schoolId).then(resp => {
            setMyCreatedFiles(resp.data.list)
            // setLoading(false)
        }).catch(err => {
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }

    const createFile = async (data) => {
        const fileData = new FormData();
        for (var key in data) {
            fileData.append(key, data[key])
        }
        setLoading(true)
        await hospitalServices.createFileFolder(fileData).then((resp) => {
            setLoading(false)
            showSuccessMessage({ message: "Created successfully" })
            getMyFiles(idHospital)
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }

    const deleteFile = (obj) => {
        setLoading(true)
        hospitalServices.deleteFileFolder(obj).then(resp => {
            setLoading(false)
            getMyFiles(idHospital)
            showSuccessMessage({ message: "File Removed" })
        }).catch(err => setLoading(false))
    }

    const shareFolders = (data) => {
        setLoading(true)
        const obj = {
            custom_file_id: data.custom_file_id,
            shared_to: data.shared_to,
            shared_users: data.shared_users
        }
        hospitalServices.shareFolders(obj).then(resp => {
            setLoading(false)
            showSuccessMessage({ message: "File Shared" })
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }

    const signauredDocsFolder = (query) => {
        hospitalServices.getSignaturedDocs(query).then(resp => {
            setSignaturedFolders(resp.data.list)
        })
    }


    const administrativeQuery = _.debounce((type, value) => {
        setLoading(true)
        hospitalServices.getSharedFiles(type, `&name=${value}`).then(resp => {
            setLoading(false)
            !resp.data.length > 0 ? showErrorMessage({ message: " NO Data Found" }) : showSuccessMessage({ message: " Found exact match" })

            setFilesData(resp.data)
            Administrative_Ref.current.scrollIntoView({ behavior: "smooth" })
        }).catch(err => {
            setLoading(false)

            showErrorMessage({ message: err.response.data.errors.msg })
        })

    }, 1000);

    const filesQuery = _.debounce((id, value) => {
        setLoading(true)
        hospitalServices.getFileFolder(id, `&name=${value}`).then(resp => {
            setLoading(false)
            !resp.data.list.length > 0 ? showErrorMessage({ message: " NO Data Found" }) : showSuccessMessage({ message: " Found exact match" })

            Files_Ref.current.scrollIntoView({ behavior: "smooth" })
            setMyCreatedFiles(resp.data.list)
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }, 1000);

    const contractQuery = _.debounce((type, value) => {
        setLoading(true)
        schoolServices.getSignaturedDocs(type, `&school_name=${value}`).then(resp => {
            setLoading(false)
            !resp.data.list.length > 0 ? showErrorMessage({ message: " NO Data Found" }) : showSuccessMessage({ message: " Found exact match" })
            Contracts_Ref.current.scrollIntoView({ behavior: "smooth" })

            setSignaturedFolders(resp.data.list)
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }, 1000);


    const filterQuery = (e) => {

        if (filterdata.type === "Administrative") {
            administrativeQuery(idHospital, filterdata.data)

        } else if (filterdata.type === "Contracts") {
            contractQuery("folder", filterdata.data)



        }
        else if (filterdata.type === "files") {

            filesQuery(idHospital, filterdata.data)


        }


    }

    return (
        <div className="dashbrd_pg">
            <SchoolHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    {loading && <LoadingBar />}
                    <div className="prfl_wrap">

                        <div className="pg_hdng mb-4 db-sub-btn">
                            <h2>Hospital Dashboard</h2>
                            <Form id="form1">
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlTextarea1"
                                >
                                    <Form.Select aria-label="Default select example"
                                        name="hospital_id"
                                        onChange={(e) => {
                                            if (e.target.value === "none") {
                                                setFilterdata({ select: false })

                                            } else {
                                                setFilterdata({ select: true, type: e.target.value })

                                            }

                                        }}
                                        required
                                    >
                                        <option value={`none`}>Filter By </option>
                                        <option value={`Administrative`} >Administrative Files </option>
                                        <option value={`files`}> MyFiles </option>
                                        <option value={`Contracts`}>Student Contracts</option>

                                    </Form.Select>
                                </Form.Group>

                                {filterdata.select && <div className="d-flex">
                                    <Form.Control
                                        value={filterdata.data}
                                        type={"text"}
                                        placeholder={`Search in here...`}
                                        onChange={(e) => {
                                            setFilterdata({ ...filterdata, data: e.target.value })
                                        }}

                                    />
                                    <Button
                                        className="btn_theme "
                                        onClick={(e) => {
                                            filterQuery(e)
                                        }}
                                    >
                                        {<FaChevronRight />}
                                    </Button>



                                </div>}
                            </Form>
                            <div className="db-sub-btn">
                                {hospitalData?.is_auth_sub_admin ? hospitalData?.auth_sub_admin_privilege?.my_files === "true" && <div style={{ marginLeft: "10px" }}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="" className="btn_theme" id="dropdown-basic">
                                            Create Document
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }}>File</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }}>Folder</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div> : <div style={{ marginLeft: "10px" }}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="" className="btn_theme" id="dropdown-basic">
                                            Create Document
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }}>File</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }}>Folder</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>}
                                {

                                    hospitalData && !hospitalData?.is_auth_sub_admin &&
                                    <div style={{ marginLeft: "10px" }}>
                                        <Dropdown>
                                            <Dropdown.Toggle style={{ width: "155px" }} variant="" className="btn_theme" id="dropdown-basic">
                                                +Add
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => { navigate(`/Co-User/hospital/${hospitalData.hospitalInfo.user_id}`) }}>Co-User</Dropdown.Item>
                                                <Dropdown.Item onClick={() => { navigate(`/Sub-Admin/hospital/${hospitalData.hospitalInfo.user_id}`) }}>Sub-Admin</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>



                                }

                            </div>



                        </div>
                        <Row>
                            <Col sm={7}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                My Schedule
                                            </h4>
                                        </div>
                                        <div className="clndr_card d-flex">
                                            <div className="dash_clndr">
                                                <Calendar
                                                    onChange={(e) => {
                                                        onChange(e)
                                                    }}
                                                    value={date}
                                                    minDate={new Date('01-01-1970')}
                                                />
                                            </div>
                                            <RotationReq UtilityList={UtilityList.dayRotation.length > 0 && UtilityList?.dayRotation} />
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {hospitalData?.is_auth_sub_admin ? hospitalData?.auth_sub_admin_privilege?.administrative_docs == "true" && <Col sm={12}>
                                <Card className="pg_card" ref={Administrative_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Administrative Files
                                            </h4>
                                        </div>

                                        <FileStructure shardFiles={files} />



                                    </Card.Body>
                                </Card>
                            </Col> : <Col sm={5}>
                                <Card className="pg_card" ref={Administrative_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Administrative Documents
                                            </h4>
                                        </div>

                                        <FileStructure shardFiles={files} />



                                    </Card.Body>
                                </Card>
                            </Col>}

                            <Col md={12}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Student Files
                                            </h4>
                                        </div>

                                        <RotationReqSchool shardFiles={studentlist} />

                                    </Card.Body>
                                </Card>
                            </Col>

                            

                            {hospitalData?.is_auth_sub_admin ? hospitalData?.auth_sub_admin_privilege?.my_files === "true" && <Col md={12}>
                                <Card className="pg_card" ref={Files_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng"  >
                                            <h4 className="mb-0">
                                                My Files
                                            </h4>
                                        </div>
                                        <MyCreatedFilesStructure shardFiles={myCreatedFile} deleteFile={deleteFile} shareFolders={shareFolders} />

                                    </Card.Body>
                                </Card>
                            </Col> : <Col md={12}>
                                <Card className="pg_card" ref={Files_Ref}>

                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                My Files
                                            </h4>
                                        </div>
                                        <MyCreatedFilesStructure shardFiles={myCreatedFile} deleteFile={deleteFile} shareFolders={shareFolders} />

                                    </Card.Body>
                                </Card>
                            </Col>}

                            {hospitalData?.is_auth_sub_admin ? hospitalData?.auth_sub_admin_privilege?.student_contracts === "true" && <Col md={12}>
                                <Card className="pg_card" ref={Contracts_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Student Contracts
                                            </h4>
                                        </div>
                                        <SignaturedContracts shardFiles={signaturedFolders} />



                                    </Card.Body>
                                </Card>
                            </Col> : <Col md={12}>
                                <Card className="pg_card" ref={Contracts_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Student Contracts
                                            </h4>
                                        </div>
                                        <SignaturedContracts shardFiles={signaturedFolders} />
                                    </Card.Body>
                                </Card>
                            </Col>}
                        </Row>
                    </div>


                    <Modal show={fileOpen.isFileOpen} onHide={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Create New File
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label> Add New File</Form.Label>
                                        <Form.Control
                                            type="file"
                                            fullWidth
                                            name="file"
                                            required
                                            placeholder="Enter Department's Name"
                                            onChange={(e) => {
                                                setFileName({
                                                    ...fileName,
                                                    "name": e.target.files[0],
                                                    "type": "file",
                                                    "createdBy_id": idHospital

                                                })
                                                // fileData.append("name", e.target.files[0]);
                                                // fileData.append("type", "file");
                                                // fileData.append("createdBy_id", idHospital);
                                                // setFileName(fileData);
                                            }}
                                        />
                                    </Form.Group>


                                    <Form.Group
                                        controlId="formFile"
                                        className=" mui_dtpickr"
                                    >

                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <Form.Label>
                                                Expiration Date (optional)
                                            </Form.Label>

                                            <DatePicker
                                                placeholder="Enter Graduation Date"
                                                className="form-control"
                                                value={fileName?.expiration_time ? fileName.expiration_time : null}
                                                onChange={(newValue) => {
                                                    if (newValue._d) {
                                                        setFileName({
                                                            ...fileName,
                                                            "expiration_time": newValue._d,
                                                        })
                                                        // fileData.append("expiration_date", newValue._d);
                                                        // setFileName(fileData)
                                                    }

                                                }}


                                                renderInput={(
                                                    params
                                                ) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                    />
                                                )}
                                                minDate={new Date()}
                                            />
                                        </LocalizationProvider>
                                    </Form.Group>


                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >

                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            onClick={async (e) => {
                                                await createFile(fileName).then(res => setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }))

                                            }}
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={fileOpen.isFolderOpen} onHide={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Create New Folder
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form
                                    onSubmit={async (e) => {
                                        e.preventDefault()
                                        await createFile(folderName).then(res => setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }))
                                    }}
                                >
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label> Add New Folder</Form.Label>
                                        <Form.Control
                                            type="text"
                                            fullWidth
                                            name="file"
                                            required
                                            placeholder="Enter Folder's Name"
                                            onChange={(e) => {
                                                setFolderName({
                                                    name: e.target.value,
                                                    type: "folder",
                                                    createdBy_id: idHospital
                                                });
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >
                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            type="submit"
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>
                </Container>
            </div >
            <Footer />
        </div >
    );
};

export default HospitalDashboard;
